import React, { useEffect, useState } from "react";
import useApi from "../CustomHooks/useApi";
import { financeAPI } from "../../api/apiClient";
import "../../css/Finance/FinanceTripsList.css";
import { Link } from "react-router-dom";
import LoadingOverlay from "../../LoadingOverlay.js";


const statusLabels = {
    2: {
        label: "Gotowe do rozliczenia",
        className: "ready"
    },
    3: {
        label: "W trakcie rozliczenia",
        className: "inprogress"
    },
    4: {
        label: "Rozliczone",
        className: "settled"
    },
    5: {
        label: "Zamknięte",
        className: "archived"
    },
};


const FinanceTripsList = ({ refreshTrigger }) => {
    const [trips, setTrips] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const [collapsedSections, setCollapsedSections] = useState({
        5: true,
    });

    const { callApi, isLoading } = useApi();


    useEffect(() => {
        callApi(
            () => financeAPI.getTripsOverview(),
            (data) => setTrips(data ?? [])
        );
    }, [refreshTrigger]);


    const groupedTrips = trips.reduce((acc, trip) => {
        const group = trip.settlementStatus;

        acc[group] = acc[group] || [];
        acc[group].push(trip);

        return acc;
    }, {});


    const formatDate = (
        date,
        opts = {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        }
    ) =>
        date
            ? new Date(date).toLocaleDateString(
                  "pl-PL",
                  opts
              )
            : "—";


    const visibleStatuses = [2, 3, 4, 5];
    const isSearching = searchTerm.trim().length > 0;


    const filterTrips = (trips) =>
        trips.filter((trip) => {
            const term = searchTerm
                .trim()
                .toLowerCase();

            if (!term) {
                return true;
            }

            return (
                (
                    trip.tripCode &&
                    trip.tripCode
                        .toLowerCase()
                        .includes(term)
                ) ||
                (
                    trip.name &&
                    trip.name
                        .toLowerCase()
                        .includes(term)
                )
            );
        });


    return (
        <div className="finance-trips-container">

            {isLoading && (
                <LoadingOverlay text="Ładowanie wycieczek..." />
            )}


            {!isLoading && (
                <>

                    <div className="finance-trips-search">
                        <input
                            type="text"
                            placeholder="Filtruj po kodzie lub nazwie wycieczki..."
                            value={searchTerm}
                            onChange={(e) =>
                                setSearchTerm(
                                    e.target.value
                                )
                            }
                        />
                    </div>


                    {visibleStatuses.map((status) => {
                        const sectionTrips = filterTrips(
                            groupedTrips[status] || []
                        ).sort(
                            (a, b) =>
                                new Date(b.startDate) -
                                new Date(a.startDate)
                        );

                        const isSectionCollapsed =
                            !isSearching && collapsedSections[status];


                        return (
                            <div
                                key={status}
                                className={`finance-trips-section ${statusLabels[status].className}`}
                            >

                                <div
                                    className="finance-trips-section-header collapsible"
                                    onClick={() =>
                                        setCollapsedSections(
                                            (prev) => ({
                                                ...prev,
                                                [status]:
                                                    !prev[
                                                        status
                                                    ],
                                            })
                                        )
                                    }
                                >

                                    <span>
                                        {
                                            statusLabels[
                                                status
                                            ].label
                                        }
                                    </span>


                                    <span
                                        className={`finance-trips-collapse-icon ${
                                            isSectionCollapsed
                                                ? "collapsed"
                                                : ""
                                        }`}
                                    >
                                        <i className="fa-solid fa-chevron-up" />
                                    </span>

                                </div>


                                {!isSectionCollapsed && (
                                    <div className="finance-trips-list">

                                        {sectionTrips.length ===
                                        0 ? (
                                            <div className="empty-message">
                                                --- Brak wycieczek ---
                                            </div>
                                        ) : (
                                            sectionTrips.map(
                                                (trip) => (
                                                    <Link
                                                        className="finance-trip-card"
                                                        key={
                                                            trip.tripGuid
                                                        }
                                                        to={`trip/${trip.tripGuid}`}
                                                        state={{
                                                            tripName:
                                                                trip.name,
                                                        }}
                                                    >

                                                        {trip.photoLink && (
                                                            <img
                                                                src={
                                                                    trip.photoLink
                                                                }
                                                                alt="Miniatura wycieczki"
                                                                className="finance-trip-thumbnail"
                                                            />
                                                        )}


                                                        <div className="finance-trip-content">

                                                            <div className="finance-trip-date">
                                                                {formatDate(
                                                                    trip.startDate
                                                                )}{" "}
                                                                –{" "}
                                                                {formatDate(
                                                                    trip.endDate
                                                                )}
                                                            </div>


                                                            <div className="finance-trip-title">

                                                                <span className="trip-code">
                                                                    [
                                                                    {
                                                                        trip.tripCode
                                                                    }
                                                                    ]
                                                                </span>{" "}

                                                                {
                                                                    trip.name
                                                                }

                                                            </div>


                                                            {trip.takenByUserName && (
                                                                <div className="finance-trip-meta">

                                                                    Przejęta przez:{" "}

                                                                    <strong>
                                                                        {
                                                                            trip.takenByUserName
                                                                        }

                                                                        {trip.lastSettlementStatusChangedAt && (
                                                                            <>
                                                                                {" "}
                                                                                (
                                                                                {formatDate(
                                                                                    trip.lastSettlementStatusChangedAt,
                                                                                    {
                                                                                        day: "2-digit",
                                                                                        month: "2-digit",
                                                                                        year: "numeric",
                                                                                    }
                                                                                )}
                                                                                )
                                                                            </>
                                                                        )}
                                                                    </strong>

                                                                </div>
                                                            )}

                                                        </div>

                                                    </Link>
                                                )
                                            )
                                        )}

                                    </div>
                                )}

                            </div>
                        );
                    })}

                </>
            )}

        </div>
    );
};


export default FinanceTripsList;